import { elementController } from '@public-pages/runtime-core';

interface iRow {
  size: number;
  tags: HTMLElement[];

}

elementController('promote-change', ({ query, queryAll }) => {
  const tags = queryAll('[data-element="tag"]');
  const tagsContainer = query('[data-element="tags-container"]');
  const tagRow = query('#tag-row');
  const tagsContainerWidth = tagsContainer?.getBoundingClientRect()?.width || 0;
  const spacing = 16;

  const allRows = tags.reduce((rows: iRow[], tag: HTMLElement) => {
    const tagWidth = tag.getBoundingClientRect().width

    if (rows.length === 0) {
      return [
        {
          size: tagWidth + spacing,
          tags: [ tag ]
        }
      ]
    } else {
      const lastRowIndex = rows.length - 1;
      let lastRow: iRow = rows[lastRowIndex]

      if (lastRow?.size >= tagsContainerWidth - tagWidth) {
        return [
          ...rows,
          {
            size: tagWidth,
            tags: [ tag ]
          }
        ]
      } else {
        rows[lastRowIndex] = {
          size: lastRow?.size + tagWidth + spacing,
          tags: [ ...lastRow?.tags, tag]
        }

        return rows
      }
    }

  }, [])

  allRows.map(row => {
    const div = document.createElement('div');
    tagRow?.classList.forEach(item => div.classList.add(item));

    row.tags.map(tag => {
      div.append(tag)
    })

    tagsContainer?.append(div);
  })

  tagRow?.remove();
  tagsContainer?.classList.add('promote-change__tags--show');
});
